import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timePeriod',
  standalone: true
})
/**
 * 將 HHmm 格式（例如：0915）轉換為 上午/下午 格式（例如：上午 09:15）
 */
export class TimePeriodPipe implements PipeTransform {
  transform(value: string): string {
    // 驗證格式是否為 4 位數字 (HHmm)
    if (!/^\d{4}$/.test(value)) {
      return '';
    }

    // 解析小時與分鐘
    const hours = parseInt(value.substring(0, 2), 10);
    const minutes = parseInt(value.substring(2, 4), 10);

    // 檢查數值是否在合法時間範圍內
    if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
      return '';
    }

    // 建立一個虛擬日期物件（日期不重要，我們只取時間部分）
    const date = new Date();
    date.setHours(hours, minutes, 0, 0);

    // 使用 Intl API 進行格式化
    // hour12: true 會啟用 12 小時制並帶上 上午/下午
    // hour: '2-digit' 會自動補零（如 09）
    return new Intl.DateTimeFormat('zh-TW', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).format(date);
  }
}